import styled, { css } from 'styled-components'
import { RadioProps } from '.'

type WrapperProps = {
  isChecked: boolean
  showBackground: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, isChecked, showBackground }) => css`
    display: flex;
    align-items: center;
    ${showBackground
      ? `border: 1px solid
      ${isChecked ? theme.colors.secondary : theme.colors.lightGray};`
      : ''}
    border-radius: ${theme.border.radius.small};
    height: ${showBackground ? '48px' : ''};
    padding: ${showBackground ? '16px' : '8px 0'};
    background-color: ${showBackground ? theme.colors.white : ''};
    cursor: pointer;
  `}
`

type InputProps = {
  inputColor: 'secondary' | 'primary'
}

export const Input = styled.input<InputProps>`
  ${({ theme, inputColor }) => {
    // const realColor = theme.colors[inputColor]
    const dsColor =
      inputColor === 'primary'
        ? theme.ds.colors.primary300
        : theme.ds.colors.primary600
    return css`
      flex-shrink: 0;
      display: flex;
      position: relative;
      align-items: center;
      justify-content: center;
      appearance: none;
      width: 20px;
      height: 20px;
      border: 2px solid ${dsColor};
      border-radius: 50%;
      background: transparent;
      transition: background ${theme.transition.fast};
      outline: none;
      cursor: pointer;
      &:before {
        content: '';
        width: 16px;
        height: 16px;
        border: 4px solid ${theme.colors.white};
        box-shadow: 0 0 0 2px ${dsColor};
        border-radius: 50%;
        background: ${dsColor};
        transition: opacity ${theme.transition.fast};
        opacity: 0;
        position: absolute;
      }
      &:checked {
        & + ${Label} {
          /* color: ${dsColor}; */
          color: ${theme.colors.gray};
        }
        & ~ div {
          border-color: ${dsColor};
        }
        &:before {
          opacity: 1;
        }
      }
    `
  }}
`

export const Label = styled.label<Pick<RadioProps, 'checked'>>`
  ${({ theme }) => css`
    display: block;
    color: ${theme.colors.gray};
    margin-left: 8px;
    width: 100%;
    cursor: pointer;
  `}
`
